module.exports = __webpack_public_path__ + "static/img/banner3资金安全.4042421.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner3资金安全.jpg
// module id = j+Id
// module chunks = 1